import {getAPIGatewayPostRequest, getNodeId} from "../util/Util";
import {ENDPOINT_GET_ADTA_STATUS, ENDPOINT_GET_ADTF_STATUS} from "../util/Constants";
import {getAPIGatewayDataFromParent} from "../handler/ParentDataHandler";

export async function getAdtaDeviceStatus(macAddressList) {
    const request = {
        nodeId: getNodeId(),
        macAddressList: macAddressList
    }
    const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_ADTA_STATUS);
    return await getAPIGatewayDataFromParent(args);
}

export async function getAdtfDeviceStatus(macAddressList) {
    const request = {
        nodeId: getNodeId(),
        macAddressList: macAddressList
    }
    const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_ADTF_STATUS);
    return await getAPIGatewayDataFromParent(args);
}


// WEBPACK FOOTER //
// ./src/components/resources/StatusResource.js